<div class="container text-center">
  <h1 class="text-danger text-center my-3">You seems to be lost!</h1>
  <img src="../../../assets/404.svg" alt="404" height="350" width="auto" />
</div>
